import { createCRUDEndpoints } from '@/api/factory/crud';
import { AdJSON } from '@/store/modules/ads/ad';
import { PublishStatus } from '@/store/types';
import httpClient from '@/api/http-client';
import { Paginated, RequestConfig } from '../types';

export type ListParams = {
  name?: string;
  search?: string;
  status?: PublishStatus | string;
  completed?: boolean | string;
  scheduled?: boolean | string;
  page?: string | number;
  sort?: string;
  direction?: 'asc' | 'desc';
  products?: number[];
  countries?: number[];
};

export type ActiveParams = {
  countries?: number[];
  products?: string[];
};

export const {
  list,
  get,
  store,
  remove,
  restore,
} = createCRUDEndpoints<AdJSON, ListParams>({
  slug: {
    base: 'ads',
    list: 'ads',
    get: 'ad',
    store: 'ad',
    remove: 'ad'
  }
});

export function active(params?: ActiveParams, config?: RequestConfig) {
  return httpClient.get<AdJSON[]>('ads/active', { params, ...config });
}

export interface AdClickUser {
  user_id: number | null;
  name: string | null;
  email: string | null;
  click_count: number;
  last_clicked_at: string;
}

export function clickUsers(id: number, page = 1, config?: RequestConfig) {
  const requestConfig: RequestConfig = { ...config, background: true };
  return httpClient.get<Paginated<AdClickUser[]>>(`ad/${id}/clicks`, { ...requestConfig, params: { page } });
}

export async function recordClick(id: number) {
  // One UUID per user click; re-sending the same request cannot double count it.
  const bytes = window.crypto.getRandomValues(new Uint8Array(16));
  bytes[6] = (bytes[6] & 0x0f) | 0x40;
  bytes[8] = (bytes[8] & 0x3f) | 0x80;
  const hex = Array.from(bytes, (byte) => byte.toString(16).padStart(2, '0')).join('');
  const eventId = `${hex.slice(0, 8)}-${hex.slice(8, 12)}-${hex.slice(12, 16)}-${hex.slice(16, 20)}-${hex.slice(20)}`;
  // Tracking failures must not display a form error or reload the page to log in.
  const config: RequestConfig = { background: true, skip_refresh: true };
  return httpClient.post<void>(`ad/${id}/click`, { event_id: eventId }, config);
}

export function listAll(
  params?: {
    search?: string;
    status?: PublishStatus;
    products?: number[];
    countries?: number[];
  },
  config?: RequestConfig,
) {
  return httpClient.get<AdJSON[]>('ads/list', { params, ...config });
}
